import type { MRT_Localization } from 'mantine-react-table';
import type { TFunction } from 'i18next';

export function buildMrtLocalization(t: TFunction): Partial<MRT_Localization> {
  return {
    actions: t('mrt.actions'),
    and: t('mrt.and'),
    cancel: t('common.cancel'),
    changeFilterMode: t('mrt.changeFilterMode'),
    changeSearchMode: t('mrt.changeSearchMode'),
    clearFilter: t('mrt.clearFilter'),
    clearSearch: t('mrt.clearSearch'),
    clearSort: t('mrt.clearSort'),
    clickToCopy: t('mrt.clickToCopy'),
    collapse: t('mrt.collapse'),
    collapseAll: t('mrt.collapseAll'),
    columnActions: t('mrt.columnActions'),
    copiedToClipboard: t('mrt.copiedToClipboard'),
    dropToGroupBy: t('mrt.dropToGroupBy'),
    edit: t('mrt.edit'),
    expand: t('mrt.expand'),
    expandAll: t('mrt.expandAll'),
    filterByColumn: t('mrt.filterByColumn'),
    filterMode: t('mrt.filterMode'),
    groupedBy: t('mrt.groupedBy'),
    hideAll: t('mrt.hideAll'),
    hideColumn: t('mrt.hideColumn'),
    max: t('mrt.max'),
    min: t('mrt.min'),
    move: t('mrt.move'),
    noRecordsToDisplay: t('mrt.noRecordsToDisplay'),
    noResultsFound: t('mrt.noResultsFound'),
    of: t('mrt.of'),
    or: t('mrt.or'),
    pinToLeft: t('mrt.pinToLeft'),
    pinToRight: t('mrt.pinToRight'),
    resetColumnSize: t('mrt.resetColumnSize'),
    resetOrder: t('mrt.resetOrder'),
    rowActions: t('mrt.rowActions'),
    rowNumber: t('mrt.rowNumber'),
    rowNumbers: t('mrt.rowNumbers'),
    rowsPerPage: t('mrt.rowsPerPage'),
    save: t('common.save'),
    search: t('mrt.search'),
    select: t('common.select'),
    selectedCountOfRowCountRowsSelected: t('mrt.selectedCountOfRowCountRowsSelected'),
    showAll: t('mrt.showAll'),
    showAllColumns: t('mrt.showAllColumns'),
    showHideColumns: t('mrt.showHideColumns'),
    showHideFilters: t('mrt.showHideFilters'),
    showHideSearch: t('mrt.showHideSearch'),
    sortByColumnAsc: t('mrt.sortByColumnAsc'),
    sortByColumnDesc: t('mrt.sortByColumnDesc'),
    sortedByColumnAsc: t('mrt.sortedByColumnAsc'),
    sortedByColumnDesc: t('mrt.sortedByColumnDesc'),
    thenBy: t('mrt.thenBy'),
    toggleDensity: t('mrt.toggleDensity'),
    toggleFullScreen: t('mrt.toggleFullScreen'),
    toggleSelectAll: t('mrt.toggleSelectAll'),
    toggleSelectRow: t('mrt.toggleSelectRow'),
    ungroupByColumn: t('mrt.ungroupByColumn'),
    unpin: t('mrt.unpin'),
  };
}
